(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savings-calculator"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var money = function(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      }).format(Math.round(value));
    };

    function pushSavingsEvent(calculator, eventName, detail) {
      var payload = Object.assign(
        {
          event: eventName,
          content_slug: calculator.dataset.trackingSlug || 'savings_calculator',
          content_cluster: 'alarm_panel',
          cta_location: calculator.dataset.ctaLocation || 'savings_calculator',
        },
        detail
      );

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    function drawChart(canvas, monthlyFee, years, upfront) {
      if (!canvas || !canvas.getContext) return;
      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      var width = canvas.clientWidth;
      var height = canvas.clientHeight;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, width, height);

      var padLeft = 56;
      var padRight = 14;
      var padTop = 12;
      var padBottom = 26;
      var plotWidth = width - padLeft - padRight;
      var plotHeight = height - padTop - padBottom;
      var maxY = Math.max(monthlyFee * 12 * years, upfront) * 1.12 || 1;
      var x = function(year) {
        return padLeft + (year / years) * plotWidth;
      };
      var y = function(value) {
        return padTop + plotHeight - (value / maxY) * plotHeight;
      };

      ctx.font = '11px -apple-system, BlinkMacSystemFont, sans-serif';
      ctx.lineWidth = 1;
      for (var i = 0; i <= 4; i += 1) {
        var val = (maxY * i) / 4;
        var yy = y(val);
        ctx.strokeStyle = '#e4e4e4';
        ctx.beginPath();
        ctx.moveTo(padLeft, yy);
        ctx.lineTo(width - padRight, yy);
        ctx.stroke();
        ctx.fillStyle = '#5c5c5c';
        ctx.textAlign = 'right';
        ctx.fillText('$' + Math.round(val).toLocaleString(), padLeft - 6, yy + 3);
      }

      ctx.textAlign = 'center';
      ctx.fillStyle = '#5c5c5c';
      var xStep = years <= 6 ? 1 : Math.ceil(years / 6);
      for (var year = 0; year <= years; year += xStep) {
        ctx.fillText(year, x(year), height - 8);
      }

      ctx.strokeStyle = '#993c1d';
      ctx.lineWidth = 2;
      ctx.beginPath();
      for (var subYear = 0; subYear <= years; subYear += 1) {
        var px = x(subYear);
        var py = y(monthlyFee * 12 * subYear);
        if (subYear === 0) {
          ctx.moveTo(px, py);
        } else {
          ctx.lineTo(px, py);
        }
      }
      ctx.stroke();

      ctx.strokeStyle = '#0f6e56';
      ctx.beginPath();
      ctx.moveTo(x(0), y(upfront));
      ctx.lineTo(x(years), y(upfront));
      ctx.stroke();
    }

    function initCalculator(calculator) {
      var feeInput = calculator.querySelector('[data-savings-fee]');
      var feeNumberInput = calculator.querySelector('[data-savings-fee-number]');
      var yearsInput = calculator.querySelector('[data-savings-years]');
      var upfrontInput = calculator.querySelector('[data-savings-upfront]');
      var chart = calculator.querySelector('[data-savings-chart]');

      if (!feeInput || !feeNumberInput || !yearsInput || !upfrontInput) return;

      if (window.location.pathname === '/pages/smart-home-security-system-no-monthly-fee') {
        var sectionNode = calculator.closest('.shopify-section') || calculator.closest('[data-savings-calculator-section]');
        var quickAnswerHeading = Array.prototype.slice.call(document.querySelectorAll('h2')).find(function(heading) {
          return heading.textContent.trim().toLowerCase().indexOf('quick answer: smart security without a required monthly fee') === 0;
        });

        if (sectionNode && quickAnswerHeading && quickAnswerHeading.parentNode && sectionNode.dataset.savingsMoved !== 'true') {
          quickAnswerHeading.parentNode.insertBefore(sectionNode, quickAnswerHeading);
          sectionNode.dataset.savingsMoved = 'true';
        }
      }

      function clampFee(value) {
        var parsed = parseInt(value, 10);
        if (Number.isNaN(parsed)) return null;
        return Math.max(1, Math.min(100, parsed));
      }

      function update(options) {
        var monthlyFee = Number(feeInput.value);
        var years = Number(yearsInput.value);
        var upfront = Number(upfrontInput.value);
        var subscriptionTotal = monthlyFee * 12 * years;
        var savingsTotal = subscriptionTotal - upfront;

        if (document.activeElement !== feeNumberInput) {
          feeNumberInput.value = monthlyFee;
        }
        calculator.querySelector('[data-savings-years-output]').textContent = years + ' yr' + (years === 1 ? '' : 's');
        calculator.querySelector('[data-savings-upfront-output]').textContent = money(upfront);
        calculator.querySelector('[data-savings-subscription-total]').textContent = money(subscriptionTotal);
        calculator.querySelector('[data-savings-konnected-total]').textContent = money(upfront);
        calculator.querySelector('[data-savings-total]').textContent = money(savingsTotal);
        calculator.querySelector('[data-savings-summary]').textContent =
          'With a ' +
          money(monthlyFee) +
          ' monthly fee over ' +
          years +
          ' years and a ' +
          money(upfront) +
          ' one-time Konnected setup, estimated savings are ' +
          money(savingsTotal) +
          '.';

        drawChart(chart, monthlyFee, years, upfront);

        if (options && options.track) {
          pushSavingsEvent(calculator, 'savings_calculated', {
            monthly_fee: monthlyFee,
            years: years,
            konnected_upfront: upfront,
            subscription_total: subscriptionTotal,
            savings_total: savingsTotal,
          });
        }
      }

      feeInput.addEventListener('input', function() {
        feeNumberInput.value = feeInput.value;
        update({ track: true });
      });

      feeNumberInput.addEventListener('input', function() {
        var clampedFee = clampFee(feeNumberInput.value);
        if (clampedFee === null) return;
        feeInput.value = clampedFee;
        feeNumberInput.value = clampedFee;
        update({ track: true });
      });

      feeNumberInput.addEventListener('blur', function() {
        var clampedFee = clampFee(feeNumberInput.value) || 1;
        feeInput.value = clampedFee;
        feeNumberInput.value = clampedFee;
        update();
      });

      [yearsInput, upfrontInput].forEach(function(input) {
        input.addEventListener('input', function() {
          update({ track: true });
        });
      });

      var productFormButton = calculator
        .closest('[data-savings-calculator-section]')
        .querySelector('[data-savings-scroll-product-form]');
      if (productFormButton) {
        productFormButton.addEventListener('click', function() {
          var productForm = document.querySelector('product-form-component, .buy-buttons-block, form[action*="/cart/add"]');
          if (productForm) {
            productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }

      window.addEventListener('resize', function() {
        update();
      });

      update();
    }

    document.querySelectorAll('[data-savings-calculator]').forEach(initCalculator);
  })();

  } catch(e) { console.error(e); }
})();
})();
